import utils from '@/utils/common';

export default function dateProgress(numberOfTasks, numberOfClosedTasks, shortForm = false) {
  const progress = numberOfClosedTasks / numberOfTasks;
  const progressInPercents = Math.round(progress * 100) || 0;

  const startText = (shortForm) ? `${progressInPercents}%` : `${progressInPercents}% выполнено`;

  const finishText = (shortForm) ? `${numberOfClosedTasks}/${numberOfTasks} задач` : utils.pluralWord(numberOfClosedTasks, 'задача', 'задачи', 'задач') + ` из ${numberOfTasks}`; // eslint-disable-line

  return {
    startText,
    finishText,
    value: progressInPercents,
  };
}
